export const post = (url, body) => {
  return fetch(url, {
    method: "post",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      "X-CSRF-Token": window.App.authenticityToken,
    },
    body: body,
    redirect: "error",
  }).then(response => {
    if (!response.ok) {
      throw new Error("HTTP error " + response.status)
    }

    return response.json()
  })
}
